/**
 * <s-countdown target="ISO datetime">: ticks the [data-unit] digits every second.
 * When the target passes it hides the closest [data-countdown-region] (or itself).
 */
class CountdownElement extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.target = Date.parse(this.getAttribute('target') || '');
    if (Number.isNaN(this.target)) return;
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  #tick() {
    const remaining = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
    if (remaining === 0) {
      clearInterval(this.#timer);
      const region = this.closest('[data-countdown-region]') || this;
      region.hidden = true;
      // Reveal the follow-up countdown (if any) that takes this one's place.
      const nextId = region.dataset ? region.dataset.countdownNext : null;
      const next = nextId ? document.getElementById(nextId) : null;
      if (next) next.hidden = false;
      return;
    }
    const values = {
      days: Math.floor(remaining / 86400),
      hours: Math.floor((remaining % 86400) / 3600),
      minutes: Math.floor((remaining % 3600) / 60),
      seconds: remaining % 60,
    };
    for (const [unit, el] of Object.entries(this.units)) {
      if (!el) continue;
      const text = String(values[unit]).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }
  }
}

if (!customElements.get('s-countdown')) {
  customElements.define('s-countdown', CountdownElement);
}
